module.exports = __webpack_public_path__ + "img/beach-fitness-female.83b8e466.jpg";